import { Base } from "ui/Scripts/source/framework/base";
import { ISavedListFilter, SavedListFilter } from "../common/savedListFilter";
import { CompanyGroupListItems, ICompanyGroupListItems } from "./companyGroupListItems";

export interface ICompanyGroupPage {
    list: ICompanyGroupListItems;
    companyFilters: ISavedListFilter[];
    userFilters: ISavedListFilter[];
}

export class CompanyGroupPage implements ICompanyGroupPage {
    list: CompanyGroupListItems;
    companyFilters: SavedListFilter[];
    userFilters: SavedListFilter[];

    constructor();
    constructor(obj: ICompanyGroupPage);
    constructor(obj?: any) {
        this.list = new CompanyGroupListItems(obj && obj.list || null);
        this.companyFilters = Base.getTypedArray(obj ? obj.companyFilters : null, SavedListFilter);
        this.userFilters = Base.getTypedArray(obj ? obj.userFilters : null, SavedListFilter);
    }
}